import HttpRequest from './request';

function getQueryParam(param) {
  if (!window.location.search) {
    let reg = new RegExp('(^|&)' + param + '=([^&]*)(&|$)', 'i');
    if (window.location.hash.indexOf('?') < 0) return null;
    let r = window.location.hash.split('?')[1].match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
  } else {
    let reg = new RegExp('(^|&)' + param + '=([^&]*)(&|$)', 'i');
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
  }
}

if (!getQueryParam('client_uid')) {
  sessionStorage.setItem('client_uid', '8c41392a7642d7af0720f62a8646de56');
  // throw new Error('client_uid不存在');
} else {
  sessionStorage.setItem('client_uid', getQueryParam('client_uid'));
}

if (!getQueryParam('uri')) {
  sessionStorage.setItem('uri', 'https://www.yunqingsmart.com');
  // throw new Error('uri不存在');
} else {
  sessionStorage.setItem('uri', getQueryParam('uri'));
}

const https = new HttpRequest(sessionStorage.getItem('client_uid'));

export default https;
